import React from "react";
import { Box, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import DataDetailsRow from "./DataDetailsRow";

const DataDetailsTable = ({ details }) => (
  <Box sx={{
    background: '#fff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderTop: 'none',
    marginTop: '-5px',
    padding: '10px',
    borderRadius: '0 0 10px 10px'
  }}>
    <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 0px' }}>
      <TableHead sx={{ backgroundColor: '#fff' }}>
        <TableRow>
          <TableCell sx={{ padding: '10px 16px', border: 'none', minWidth: '32px', maxWidth: '32px', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}>#</TableCell>
          <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'left' }}>Project</TableCell>
          <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'left' }}>Memeber</TableCell>
          <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'left' }}>Percent used</TableCell>
          <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'center' }}>Time Spent</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {details.map((detail, i) => (
          <DataDetailsRow key={i} detail={detail} index={i} rowDetails={details} />
        ))}
      </TableBody>
    </Table>
  </Box>
);

export default DataDetailsTable;